import React from 'react';
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

const OccurrenceObjects = ({data}) => {
    const objects = data.objects ?? []
    if (!objects.length || !objects) return null;

    return (
        <>
            { objects && (
                <section className="space-y-4! px-5!">
                    { objects.map((item, index) => {

                        const info = [
                            {
                                label: "Tipo",
                                value: item?.type ?? "",
                            },
                            {
                                label: "Subtipo",
                                value: item?.subtype ?? "",
                            },
                            {
                                label: "Quantidade",
                                value: item?.quantity ?? "",
                            },
                            {
                                label: "Unidade",
                                value: item?.unit ?? "",
                            },
                            {
                                label: "Pessoa relacionada",
                                value: item?.personName ?? "",
                            },
                            {
                                label: "Descrição",
                                value: item?.description ?? "",
                            }
                        ];

                        return (
                            <>
                                <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]! print:break-after-avoid! mb-2">
                                    OBJETO - {index + 1}
                                </h2>

                                <InfoGrid key={`${index}`} title={""} items={info} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'px-0!'} contentClassName={'space-y-1'}/>
                            </>
                        )

                    })}
                </section>
            )}
        </>
    );
};

export default OccurrenceObjects;